/**
 * @author 王宇
 * @date 2019/5/24
 * @Description: 校验公共方法
 */
// 账号
let codeReg = /^(?![0-9]*$)(?![a-zA-Z]*$)[a-zA-Z0-9]{6,20}$/;
// 电话
let phoneReg = /^[1][3,4,5,6,7,8,9][0-9]{9}$/;

// 必须为数字
let numberReg = /^\d+$|^\d+[.]?\d+$/;
//数字，一位小数
let oneNum =/^\d*\.{0,1}\d{0,1}$/;

/^\d*\.{0,1}\d{0,1}$/

// 密码
let passwordReg = /^(?![\d]+$)(?![a-zA-Z]+$)(?![^\da-zA-Z]+$)([^\u4e00-\u9fa5\s]){6,20}$/;

// 联系人
let contactsReg = /^[\u0391-\uFFE5A-Za-z]+$/;

let regId = /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/;

let emailReg = /^[A-Za-z\d]+([-_.][A-Za-z\d]+)*@([A-Za-z\d]+[-.])+[A-Za-z\d]{2,4}$/;
// 折扣
let discountReg = /^[1-9][0-9]?$/;

let FormValidate = (function () {
  function FormValidate() { }
  // From表单验证规则  可用于公用的校验部分
  FormValidate.Form = function () {
    return {
      //折扣验证
      validateDiscount(rule, value, callback) {

        if (!value) {
          return callback(new Error("请输入折扣"));
        }
        if (!discountReg.test(value)) {
          callback(new Error("必须为1-99数字"));
        } else {
          callback();
        }

      },
      // 账号的验证规则
      validateCode(rule, value, callback) {
        if (!value) {
          return callback(new Error("请输入账号"));
        }
        if (!codeReg.test(value)) {
          callback(new Error("账号必须为6-20位字母和数字组合"));
        } else {
          callback();
        }
      },

      // 只能数字的验证
      validateNumber(rule, value, callback) {
        if (!!value) {
          if (!oneNum.test(value)) {
            callback(new Error("必须为数字"));
          } else {
            callback();
          }
        } else {
          callback();
        }
      },

      // 密码的验证
      validatePsdReg(rule, value, callback) {
        if (!value) {
          return callback(new Error("请输入密码"));
        }
        if (!passwordReg.test(value)) {
          callback(
            new Error(
              "请输入6-20位英文字母、数字或者符号（除空格），且字母、数字和标点符号至少包含两种"
            )
          );
        } else {
          callback();
        }
      },

      // 联系人
      validateContacts(rule, value, callback) {
        if (!value) {
          return callback(new Error("请输入联系人"));
        }
        if (!contactsReg.test(value)) {
          callback(new Error("联系人不可输入特殊字符"));
        } else {
          callback();
        }
      },

      // 邮箱的验证规则
      validateEmail(rule, value, callback) {
        if (value !== "") {
          if (!emailReg.test(value)) {
            callback(new Error("邮箱格式不正确"));
          } else {
            callback();
          }
        } else {
          callback();
        }
      },
    // 个人中心电话号码的验证（如果带星不予判断）
    validatePhoneForm(rule, value, callback) {
      if (value) {
        if(value.split('*').length>1){
          callback();
        }
        else if (!phoneReg.test(value)) {
          callback(new Error("手机格式不正确"));
        } else {
          callback();
        }
      } else {
        callback();
      }
    },
      // 个人中心身份证的验证规则（如果带星不予判断）
      IDForm(rule, value, callback) {
        if (value) {
          if(value.split('*').length>1){
            callback();
          }
          else if (!regId.test(value)) {
            callback(new Error("请输入正确的二代身份证号码"));
          } else {
            callback();
          }
        } else {
          callback();
        }
      },
      // 电话号码的验证
      validatePhone(rule, value, callback) {
        if (value) {
         if (!phoneReg.test(value)) {
            callback(new Error("手机格式不正确"));
          } else {
            callback();
          }
        } else {
          callback();
        }
      },
      // 身份证的验证规则
      ID(rule, value, callback) {
        if (value) {
          if (!regId.test(value)) {
            callback(new Error("请输入正确的二代身份证号码"));
          } else {
            callback();
          }
        } else {
          callback();
        }
      }
    };
  };

  return FormValidate;
})()

exports.FormValidate = FormValidate;



// WEBPACK FOOTER //
// ./src/common/rules.js